<template>
  <div class="integral-borrowing">
    <div class="list-search">
      <a-form>
        <a-row>
          <a-col class="search-item" :span="6">
            <a-form-item
              label="买家姓名"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-input v-model="tradeName" allow-clear placeholder="请输入买家姓名" />
            </a-form-item>
          </a-col>
          <a-col class="search-item" :span="6">
            <a-form-item
              label="订单状态"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-select
                v-model="commGroup"
                allow-clear
                placeholder="全部"
                show-search
                option-filter-prop="children"
              >
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option :value="2">
                  买家入库
                </a-select-option>
                <a-select-option :value="6">
                  待取货
                </a-select-option>
                <a-select-option :value="4">
                  租借中
                </a-select-option>
                <a-select-option :value="7">
                  已完成
                </a-select-option>
                <a-select-option :value="5">
                  已逾期
                </a-select-option>
                <a-select-option :value="8">
                  已取消
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col class="search-item" :span="6">
            <a-form-item
              label="近期交易"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-range-picker v-model="date" :format="dateFormat" :value-format="valueFormat" />
            </a-form-item>
          </a-col>

          <a-col class="search-item city" :span="6">
            <a-form-item
              label="区域"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-cascader
                v-model="areaContain"
                :options="options"
                :load-data="loadData"
                :field-names="{
                  label: 'name',
                  value: 'id',
                  children: 'children'
                }"
                placeholder="省市区"
                change-on-select
                @change="onAreaChange"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="search-item">
            <a-form-item
              label="回收点名称"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-input v-model="postStationName" allow-clear placeholder="请输入回收点" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col class="search-item" :span="24" align="right">
            <a-form-item>
              <a-button type="primary" class="mr8" @click="toSearch">
                查询
              </a-button>
              <a-button @click="resetTable">
                重置
              </a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :data-source="tableData"
        :pagination="pagination"
        :row-key="record => record.id"
        :loading="loading"
        class="table-content"
        :scroll="{y:'50vh'}"
        @change="handleTableChange"
      >
        <template slot="storeImg" slot-scope="storeImg">
          <img :src="storeImg">
        </template>
        <template slot="userInfo" slot-scope="text, record">
          <div class="userInfo">
            <div> 姓名：</div>
            <span>{{ record.userName }}</span>
          </div>
          <div class="userInfo">
            <div>联系方式：</div>
            <span>{{ record.cellPhone }}</span>
          </div>
        </template>
        <template slot="operate" slot-scope="text">
          <a-button type="link" size="small" @click="view(text)">
            订单详情
          </a-button>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { getArea, getEstate } from '@/components/mixins/mixins.js'
import { getGoodsList } from '@/api/orderManage'
import { unixToDate } from '@/utils/formatDate'
const columns = [
  {
    title: '订单编号',
    key: 'orderNo',
    dataIndex: 'orderNo',
    // customRender: (text, record, index) => index + 1,
    align: 'center'
  },
  {
    title: '买家信息',
    key: 'userInfo',
    dataIndex: 'userInfo',
    width: 200,
    scopedSlots: { customRender: 'userInfo' },
    align: 'center'
  },
  {
    title: '取货点',
    key: 'name',
    dataIndex: 'name',
    align: 'center'
  },
  {
    title: '配送方式',
    key: 'beginBusinessTime',
    dataIndex: 'beginBusinessTime',
    customRender: () => '买家自取',
    align: 'center'
  },
  {
    title: '实扣积分（环保值）',
    key: 'totalPrice',
    dataIndex: 'totalPrice',
    align: 'center'
  },
  {
    title: '订单状态',
    key: 'state',
    dataIndex: 'state',
    customRender: (text, record, index) => {
      switch (text) {
        case 0:
          return '待付款'
        case 1:
          return '付款完成'
        case 2:
          return '卖家入库'
        case 4:
          return '租赁中'
        case 5:
          return '超时'
        case 6:
          return '买家取货'
        case 7:
          return '完成'
        case 8:
          return '取消'
        case 9:
          return '退款中'
        case 10:
          return '退款完成'
        case 11:
          return '退款拒绝'
        case 12:
          return '卖家取消'
        case 13:
          return '买家取消'
        case 14:
          return '失效'
        default:
          break
      }
    },
    align: 'center'
  },
  {
    title: '下单时间',
    key: 'createTime',
    dataIndex: 'createTime',
    customRender: (text, record, index) => {
      return unixToDate(text)
    },
    align: 'center'
  },
  {
    title: '租期',
    key: 'b',
    dataIndex: 'b',
    width: 300,
    customRender: (text, record, index) => {
      return `${record.startTime} ~ ${record.endTime}`
    },
    align: 'center'
  },
  {
    title: '操作',
    key: 'operate',
    width: 150,
    fixed: 'right',
    scopedSlots: { customRender: 'operate' },
    align: 'center'
  }
]
export default {
  mixins: [getArea, getEstate],
  data () {
    return {
      columns,
      // 商品名称
      tradeName: '',
      /** 商品分组 */
      commGroup: '',
      // 发布时间
      date: [],
      dateFormat: 'YYYY/MM/DD',
      valueFormat: 'YYYY/MM/DD',
      // 回收点名称
      postStationName: '',
      /**
       * 省市区
       *
       */
      options: [],
      areaContain: [],
      /**
       * 列表
       *
       */
      // 列表数据
      tableData: [],
      // 分页数据
      pagination: {
        current: 1,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      },
      // 列表loading
      loading: false
    }
  },
  created () {
    this.getGoodsList()
  },
  mounted () {
    this.getArea('', 2, null, true)
  },
  methods: {
    // 列表
    // 获取列表
    async getGoodsList () {
      const params = {
        attribute: '3',
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        userName: this.tradeName,
        state: this.commGroup,
        name: this.postStationName,
        areaId: this.areaContain[2],
        cityId: this.areaContain[1],
        provinceId: this.areaContain[0],
        startTime: this.date[0],
        endTime: this.date[1]
      }
      this.loading = true
      try {
        const res = await getGoodsList(params)
        if (res.code === 0) {
          this.tableData = res.result.list
          this.pagination.total = res.result.totalCount
        }
      } finally {
        this.loading = false
      }
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.getGoodsList()
    },
    // 查询
    toSearch () {
      this.getGoodsList()
    },
    // 重置
    resetTable () {
      this.tradeName = ''
      this.commGroup = ''
      this.date = []
      this.areaContain = []
      this.postStationName = ''
    },
    /**
     * 省市区
     *
     */
    loadData (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      this.getArea(targetOption.id, targetOption.layer + 1, targetOption, true)
    },
    onAreaChange (value, obj) {
      this.estateList = []
      this.estate = undefined
      if (value.length < 4) {
        this.getEstate(value)
      } else if (value.length === 4) {
        this.getEstate(null, value[3])
      }
    },
    // 查看
    view (item) {
      this.$router.replace({
        path: '/integralView',
        query: { id: item.id }
      })
    }
  }
}

</script>
<style lang='less' scoped>
.integral-borrowing{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .list-search{
    width: 100%;
    margin-bottom: 16px;
    background-color: #fff;
    padding: 16px 20px 7px 20px;
    .city{
      margin-right: 10px;
    }
    .mr8{
      margin-right: 10px;
    }
  }
  .table{
    flex: 1;
    background: #fff;
    padding: 16px 20px 7px 20px;
    box-sizing: border-box;
  }
  /deep/ .ant-input,
  /deep/ .ant-col-19,
  /deep/ .ant-form-item-control,
  /deep/ .ant-cascader-picker,
  /deep/ .ant-cascader-picker-label{
    width: 220px;
  }
  .userInfo{
    display: flex;
    >div{
      flex: 1;
      text-align: left;
    }
    >span{
      flex: 1;
      text-align: left;
    }
  }
}
</style>

<style lang="stylus" scoped>
.dlMain
    width: 1
</style>

